import handleOriginSource from './preproccess/handle-origin-source'
import handleNewsSource from './preproccess/handle-news-source'
import handleOriginalNews from './preproccess/handle-original-news'
import handleShareInfo from './preproccess/handle-share-info'

class PreproccessDelegate {
  article
  preproccess_handler_list = []
  constructor (preproccess_handler_list = []) {
    this.preproccess_handler_list = preproccess_handler_list
  }

  setArticle (article) {
    this.article = article
    return this
  }

  handleContent (container) {
    return this.preproccess_handler_list.reduce((container, handler) => {
      handler(container, this.article.origin_data, this.article)
      return container
    }, container)
  }

  push (handler) {
    this.preproccess_handler_list.push(handler)
    return this
  }

  pop (handler) {
    this.preproccess_handler_list.pop(handler)
    return this
  }

  splice (...args) {
    this.preproccess_handler_list.splice(...args)
    return this
  }
}

// 默认预处理器
export const DEFAULT_PREPROCCESS_DELEGATE = new PreproccessDelegate(
  [
    handleOriginSource,
    handleOriginalNews,
    handleNewsSource,
    handleShareInfo
  ]
)

// 预处理函数
export {
  handleShareInfo,
  handleOriginSource,
  handleNewsSource,
  handleOriginalNews
}

export default PreproccessDelegate